import * as React from 'react';
import { Notice } from '../../components/Notice';
import { jsx as _jsx } from "react/jsx-runtime";
export var NoticeContainer = function NoticeContainer(_ref) {
  var notice = _ref.notice;
  if (!notice) {
    return null;
  }
  return /*#__PURE__*/_jsx(Notice, {
    text: notice
  });
};